/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { FormEvent, useState } from 'react';
import { Button, ErrorText, Field, Input } from '@/components/ui';
import { useAuth } from '@/lib/auth';
import { useBranding } from '@/lib/branding';

export function LoginPage() {
  const { login } = useAuth();
  const brand = useBranding();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [needTotp, setNeedTotp] = useState(false);
  const [err, setErr] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      const r = await login(email, password, needTotp ? totp : undefined);
      if (r === 'totp') setNeedTotp(true);
    } catch (x) { setErr(x); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-4 p-6 shadow-sm">
        <div className="flex items-center gap-2">
          <img src={brand.logo ?? '/favicon.svg'} alt="" className="h-9 w-9 object-contain" />
          <div>
            <div className="font-semibold">{brand.name}</div>
            <div className="text-xs text-slate-500">Вход в систему</div>
          </div>
        </div>
        <Field label="Электронная почта"><Input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
        <Field label="Пароль"><Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
        {needTotp && (
          <Field label="Код из приложения-аутентификатора">
            <Input inputMode="numeric" maxLength={6} autoFocus value={totp} onChange={(e) => setTotp(e.target.value.replace(/\D/g, ''))} />
          </Field>
        )}
        <ErrorText error={err} />
        <Button type="submit" className="w-full" disabled={busy}>{busy ? 'Вход...' : 'Войти'}</Button>
      </form>
    </div>
  );
}
